//@ts-check
import React, { useState } from "react";
import "./styles.css";

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export default function App() {
  const [bed, setBed] = useState(0);
  const [bath, setBath] = useState(1);
  const [type, setType] = useState("standard");
  const [comm, setComm] = useState("email");
  const [email, setEmail] = useState();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState();


  let estimate;

  if (bed < 1) {
    estimate = 220;
  } else if (bed < 2) {
    estimate = 300;
  } else if (bed < 3) {
    estimate = 345 + ((bed - 1) * 50) + ((bath - 1) * 50);
  } else if (bed < 4) {
    estimate = 315 + ((bed - 1) * 50) + ((bath - 1) * 50);
  } else if (bed < 5) {
    estimate = 300 + ((bed - 1) * 50) + ((bath - 1) * 50);
  } else {
    estimate = 300 + ((bed - 1) * 50) + ((bath - 1) * 50);
  }

  if (type === "standard") {
    estimate *= 0.8;
  }

  const handleSubmit = e => {
    const obj = {
      name: `${email} - $${estimate} - ${bed} bedrooms, ${bath} bathrooms, ${type}`,
      email: email
    }

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "residential", ...obj })
    })
      .then(() => setSuccess(true))
      .catch(error => setError(error));

    e.preventDefault();
  };

  return (
    <div className="App">
      <h2>How can we take care of you?</h2>
      <p>
        Tell us about your home and your needs, and we'll give you a price right
        now.
      </p>

      <h3>Number of bedrooms</h3>
      <div className="button-container">
        <div className="button-div">
          <div
            href="#"
            className={`button ${0 === bed && "selected"}`}
            onClick={(e) => setBed(0)}
          >
            Studio
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${1 === bed && "selected"}`}
            onClick={(e) => setBed(1)}
          >
            1
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${2 === bed && "selected"}`}
            onClick={(e) => setBed(2)}
          >
            2
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${3 === bed && "selected"}`}
            onClick={(e) => setBed(3)}
          >
            3
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${4 === bed && "selected"}`}
            onClick={(e) => setBed(4)}
          >
            4
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${5 === bed && "selected"}`}
            onClick={(e) => setBed(5)}
          >
            5
          </div>
        </div>
      </div>

      <br className="hide-mobile" />

      <h3>Number of bathrooms</h3>
      <div className="button-container">
        <div className="button-div">
          <div
            className={`button ${1 === bath && "selected"}`}
            onClick={(e) => setBath(1)}
          >
            1
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${2 === bath && "selected"}`}
            onClick={(e) => setBath(2)}
          >
            2
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${3 === bath && "selected"}`}
            onClick={(e) => setBath(3)}
          >
            3
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${4 === bath && "selected"}`}
            onClick={(e) => setBath(4)}
          >
            4
          </div>
        </div>
      </div>

      <br className="hide-mobile" />

      <h3>Clean type</h3>
      <div className="button-container">
        <div className="button-div">
          <div
            className={`button ${"standard" === type && "selected"}`}
            onClick={(e) => setType("standard")}
          >
            Standard
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${"deep-clean" === type && "selected"}`}
            onClick={(e) => setType("deep-clean")}
          >
            Deep Clean
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${"move-in" === type && "selected"}`}
            onClick={(e) => setType("move-in")}
          >
            Move In/Out
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${"post-construction" === type && "selected"}`}
            onClick={(e) => setType("post-construction")}
          >
            Post Construction
          </div>
        </div>
      </div>

      <br className="hide-mobile" />

      <h3>Best method of communication </h3>

      <div className="button-container">
        <div className="button-div">
          <div
            className={`button ${"email" === comm && "selected"}`}
            onClick={(e) => setComm("email")}
          >
            Email
          </div>
        </div>
        <div className="button-div">
          <div
            className={`button ${"phone" === comm && "selected"}`}
            onClick={(e) => setComm("phone")}
          >
            Phone
          </div>
        </div>
      </div>

      <br />

      <div className="margin"></div>

      <form name="residential" method="post" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={handleSubmit}>
        <input type="hidden" name="residential" value="residential" />

        {!success &&
          <div className="button-container subtotal">
            <div className="subtext">
              Sub Total: <span className="estimate">${estimate}</span> &nbsp; &nbsp;
        </div>
            <div className="button-div">
              <input
                type="text"
                name="name"
                value={email}
                className="input"
                hidden={true}
              />
              <input
                type="text"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
                required={true}
                placeholder={"email" === comm ? "Email" : "Phone number"}
              />
            </div>
            <div className="button-div">
              <button
                type="submit"
                className={`button actual-button`}
                onClick={(e) => setComm("email")}
              >
                Book now
          </button>
            </div>
          </div>
        }

        {success &&
          <div className="button-container subtotal">
            <div className="subtext height">
            <span className="estimate">Thank you! We'll be in touch shortly.</span>
            </div>
          </div>
        }

        {error &&
          <div className="button-container subtotal">
            <div className="subtext height">
              <br/>
            <span className="estimate">Something went wrong. Please try again later.</span>
            </div>
          </div>
        }
      </form>

      <br />
      <br />
    </div>
  );
}
